(function (window, document, $) {
    $(document).ready(function () {

        //Simple load more script to show hidden items after clicking a button (for example Training sessions)
        $("[data-simple-load-more]").click(function (e) {
            e.preventDefault();
            // get the class of the item to remove
            var hidden_class = $(this).data('simple-load-more-class');
            
            if (hidden_class.length && $('.' + hidden_class).length) {
                // remove hidden class from data-simple-load-more-item to display it
                $("[data-simple-load-more-item]").addClass('simple-load-more-visible').removeClass( hidden_class );
                $(this).find('[data-simple-load-more-text-target]').text($(this).data('simple-load-less-text'));
                $(this).addClass('items-shown');
            } else if( $('.simple-load-more-visible').length ) {
                // add hidden class from data-simple-load-more-item to hide it
                $(".simple-load-more-visible[data-simple-load-more-item]").removeClass('simple-load-more-visible').addClass( hidden_class );
                $(this).find('[data-simple-load-more-text-target]').text($(this).data('simple-load-more-text'));
                $(this).removeClass('items-shown');

                if ($('#training-content').length) {
                    $('html, body').animate({
                        //and scroll to the section
                        scrollTop: $( '#training-content' ).offset().top
                    }, 500);
                }
            }
        });
    });

}(window, document, jQuery));